var map = {
	"./adult/de/skrivehastighet-data.json": 821,
	"./adult/nn/skrivehastighet-data.json": 822,
	"./adult/no/skrivehastighet-data.json": 823,
	"./youth/de/skrivehastighet-data.json": 824,
	"./youth/nn/skrivehastighet-data.json": 825,
	"./youth/no/skrivehastighet-data.json": 826,
	"./youth/se/skrivehastighet-data.json": 827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 125;